import type { FaireProductEntity } from "../../entity_types/product";

export const p_gk6wdtetd6: FaireProductEntity = {
  token: "p_gk6wdtetd6",
  type: "product",
  name: "Elegant Slim-Fit Waist-Defining V-Neck Workwear Blazer",
  brandToken: "b_m4nc6munyv",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/6655539a6955ca3894036a634c5c4e7a0faa13a68e1f0afd5c464d3e1d92e375.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/08b9ecab17c0ee8f49770bf55ba44ebc7f62d23d05121ba633aaf3016aaa1f3b.jpeg",
    "https://cdn.faire.com/fastly/21680a37caad5b33842190e0299920b1eddf72f37c3d15549a5780add42d877c.jpeg",
    "https://cdn.faire.com/fastly/c8ac80cbbc87b955b1bec0456f7ba25d6e3363e016a76b2e8be306534592be3b.jpeg",
    "https://cdn.faire.com/fastly/4e3a8b9db06df3b204650944597134a1a59a7b8d2426829b40439ad152f99baf.jpeg",
  ],
  priceDollars: 31.32,
  description:
    "Elegant Slim-Fit Waist-Defining V-Neck Workwear Blazer_RCZY01996\n\nOur product size standards are different, please check the size information before placing an order\t\t\t\t\t\nSize Chart(inch)\t\t\t\t\t\n\tBust\tLength Waist\t   Sleeve\tShoulder\nS\t32.28 \t29.53 \t 27.56 \t24.41 \t15.16 \nM\t33.86 \t29.92 \t 29.13 \t24.80 \t15.55 \nL\t35.43 \t30.31 \t 30.71 \t25.20 \t15.94 \n\t\t\t\t\t\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2025 Women Apparel\t\t\t\t\t\n",
  tags: [],
  msrpDollars: 62.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:43.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
